module.exports = __webpack_public_path__ + "images/background/image_thumbnail/5-off-f1983f152e987ca42a79b866fad60b73.jpg";